import { Autocomplete, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, Grid, IconButton, Link, TextField, Tooltip, InputAdornment } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { CloudUpload } from "@mui/icons-material";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import * as queryString from "query-string";
import React, { useEffect, useRef, useState } from "react";
import { QrReader } from "react-qr-reader";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    getBreakdownReasonGroupList,
    getBreakdownEffectList,
    getPoolList,
    setPoolList,
    getBreakdownReasonPlaceGetListByGroupId,
    postUnplannedMaintenanceCreateWithFile,
    getEquipmentGetByBarcodeContext,
    setEquipmentGetByBarcodeContext,
} from "../../store/actions/ReportBreakDownActions";
import { getUserRoleGroupList } from "../../store/actions/userActions";
import { getFormDataFromFiles, qrScroll } from "../../common";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import Machine from "../../components/TextFields/Machine/Machine";
import FileUploaderPopup from "../../components/Popup/FileUploaderPopup";
import { useTranslation } from "react-i18next";
import CropFreeIcon from "@mui/icons-material/CropFree";
import SearchIcon from "@mui/icons-material/Search";

const useStyles = makeStyles((theme) => ({
    button: {
        width: 80,
        height: 80,
        padding: 0,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
    },
}));

export default function ReportBreakdown(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const res = useSelector(({ ReportBreakDown }) => ReportBreakDown);
    const user = useSelector(({ user }) => user);
    let [breakdownReasonGroupData, setBreakdownReasonGroupData] = useState([]);
    let [breakdownEffectData, setBreakdownEffectData] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);
    const { t } = useTranslation("translation");

    useEffect(() => {
        SetEquipment(queryString.parse(window.location.search).id, queryString.parse(window.location.search).name);
        LoadHandler();
    }, []);
    useEffect(() => {
        dispatch(getUserRoleGroupList());
        const userRoles = user.userRoleGroupList.resultObject;

        if (res.BreakdownReasonGroupList) {
            if (res.BreakdownReasonGroupList?.errorCode === 0) {
                setBreakdownReasonGroupData(res.BreakdownReasonGroupList?.resultObject);
            }
        }
        if (res.BreakdownEffectList) {
            if (res.BreakdownEffectList?.errorCode === 0) {
                setBreakdownEffectData(res.BreakdownEffectList?.resultObject);
                setPageLoaded(true);
            }
        }

        if (res.PoolList) {
            if (res.PoolList?.errorCode === 0) {
                setPoolData(res.PoolList?.resultObject);
                if (selectedBreakdownReasonGroupCode != undefined) {
                    dispatch(getBreakdownReasonPlaceGetListByGroupId(selectedBreakdownReasonGroupCode));
                } else {
                    setDetailDataLoaded(true);
                }
            }
            if (res.PoolList?.errorCode === 1) {
                setDetailDataLoaded(false);
            }
            dispatch(setPoolList(undefined));
        }
        if (res.BreakDownReasonPlaceList) {
            if (res.BreakDownReasonPlaceList?.errorCode === 0) {
                setBreakDownReasonPlaceData(res.BreakDownReasonPlaceList?.resultObject);
                setDetailDataLoaded(true);
            }
            if (res.BreakDownReasonPlaceList?.errorCode === 1) {
                setDetailDataLoaded(false);
            }
        }
        if (res.UnPlannedMaintenanceCreateFile) {
            if (res.UnPlannedMaintenanceCreateFile?.errorCode === 0) {
                if (userRoles.some((element) => element.id === 6) && userRoles.some((element) => element.id === 5)) {
                    const currentUrl = new URL(window.location.href);
                    let from = currentUrl.searchParams.get("from") || "technician";
                    if (from === "breakdown") {
                        routerHistory.push({ pathname: `/technicianmainpage` });
                    } else {
                        routerHistory.push({ pathname: `/${from}mainpage` });
                    }
                }
                //Technician Role
                else if (userRoles.some((element) => element.id === 5)) {
                    routerHistory.push({ pathname: "/technicianmainpage" });
                }
                //Operator Role
                else if (userRoles.some((element) => element.id === 6)) {
                    routerHistory.push({ pathname: "/operatormainpage" });
                }
                res.UnPlannedMaintenanceCreateFile = null;
            }
        }
    }, [res]);

    useEffect(() => {
        if (res.EquipmentByBarCode?.resultObject) {
            const result = res.EquipmentByBarCode.resultObject;
            // mainEquipment may be an object {id, name} or a string, or null/undefined
            const mainEquipmentName = typeof result?.mainEquipment === "object" && result?.mainEquipment !== null ? result?.mainEquipment?.name : result?.mainEquipment;
            const mainEquipmentId = typeof result?.mainEquipment === "object" && result?.mainEquipment !== null ? result?.mainEquipment?.id : result?.mainEquipmentId;

            if (result?.mainEquipment) {
                // Scanned equipment is a sub-equipment: fill area, main equipment, and sub equipment
                const newMachineStates = {
                    selectedAreaCode: result?.areaId,
                    selectedAreaName: result?.areaName,
                    selectedMainEquipmentCode: mainEquipmentId,
                    selectedMainEquipmentName: mainEquipmentName,
                    selectedSubEquipmentCode: result?.id,
                    selectedSubEquipmentName: result?.name,
                };
                setMachineStates(newMachineStates);
            } else {
                // Scanned equipment is a main equipment: fill only area and main equipment
                const newMachineStates = {
                    selectedAreaCode: result?.areaId,
                    selectedAreaName: result?.areaName,
                    selectedMainEquipmentCode: result?.id,
                    selectedMainEquipmentName: result?.name,
                    selectedSubEquipmentCode: null,
                    selectedSubEquipmentName: null,
                };
                setMachineStates(newMachineStates);
            }
            setQrOpen(false);
            // Reset Redux state after using it to prevent re-triggering
            dispatch(setEquipmentGetByBarcodeContext({}));
        }
    }, [res.EquipmentByBarCode]);

    const LoadHandler = () => {
        dispatch(getBreakdownReasonGroupList());
        dispatch(getBreakdownEffectList());
    };

    const SetEquipment = (id, name) => {
        if (id != null && name != null) {
            setMachineStates({ ...machineStates, selectedMainEquipmentCode: Number(id), selectedMainEquipmentName: name });
        }
    };

    //load detail data for popup
    let [breakdownReasonPlaceData, setBreakDownReasonPlaceData] = useState([]);
    let [poolData, setPoolData] = useState([]);
    const [detailDataLoaded, setDetailDataLoaded] = useState(false);
    const LoadDetailData = () => {
        dispatch(getPoolList());
    };

    //set breakdownReasonGroupCode
    let [selectedBreakdownReasonGroupCode, setSelectedBreakdownReasonGroupCode] = useState();
    const HandleBreakdownReasonGroupChange = (breakdownId) => {
        if (breakdownId != null) {
            const filteredReasonGroup = breakdownReasonGroupData.filter((item) => item.name?.includes(breakdownId) || item.breakdownReasonGroupLocalizationName?.includes(breakdownId));
            setSelectedBreakdownReasonGroupCode(filteredReasonGroup[0].id);
            setSelectedBreakdownReasonPlaceName("");
            setSelectedPoolName("");
            return filteredReasonGroup[0].id;
        } else {
            setSelectedBreakdownReasonGroupCode(0);
        }
    };

    //set breakdown effect
    let [selectedBreakdownEffect, setSelectedBreakdownEffect] = useState();
    const HandleBreakdownEffectChange = (effectId) => {
        if (effectId != null) {
            const filteredEffect = breakdownEffectData.filter((item) => item.name?.includes(effectId) || item.breakdownEffectLocalizationName?.includes(effectId));
            setSelectedBreakdownEffect(filteredEffect[0].id);
            return filteredEffect[0].id;
        } else {
            setSelectedBreakdownEffect(0);
        }
    };

    //request detail
    const [breakdownDetail, setBreakdownDetail] = useState("");
    const HandleBreakdownDetail = (event) => {
        setBreakdownDetail(event.target.value);
    };

    //set breakdownReasonPlaceCode
    let [selectedBreakdownReasonPlaceCode, setSelectedBreakdownReasonPlaceCode] = useState();
    let [selectedBreakdownReasonPlaceName, setSelectedBreakdownReasonPlaceName] = useState();
    const HandleBreakdownReasonPlaceChange = (reasonPlaceId) => {
        if (reasonPlaceId != null) {
            const filteredReasonPlace = breakdownReasonPlaceData.filter((item) => item.name.includes(reasonPlaceId));
            setSelectedBreakdownReasonPlaceCode(filteredReasonPlace[0].id);
            setSelectedBreakdownReasonPlaceName(filteredReasonPlace[0].name);

            return filteredReasonPlace[0].id;
        } else {
            setSelectedBreakdownReasonPlaceName("");
        }
    };

    //set poolCode
    let [selectedPoolCode, setSelectedPoolCode] = useState();
    let [selectedPoolName, setSelectedPoolName] = useState();

    const HandlePoolChange = (poolId) => {
        if (poolId != null) {
            const filteredPool = poolData.filter((item) => item.name.includes(poolId));
            setSelectedPoolCode(filteredPool[0].id);
            setSelectedPoolName(filteredPool[0].name);

            return filteredPool[0].id;
        } else {
            setSelectedPoolName("");
        }
    };

    //submit request
    const routerHistory = useHistory();
    const handleBreakdownSubmit = () => {
        const data = {
            notes: breakdownDetail,
            equipmentId: machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
            breakdownEffectId: selectedBreakdownEffect,
            breakdownReasonGroupId: selectedBreakdownReasonGroupCode,
            breakdownReasonPlaceId: selectedBreakdownReasonPlaceCode,
            poolId: selectedPoolCode,
        };

        formData.append("unplannedOrder", JSON.stringify(data));
        dispatch(postUnplannedMaintenanceCreateWithFile(formData));
    };

    // Machine popup
    const initialMachineStates = {
        selectedAreaCode: null,
        selectedAreaName: null,
        selectedMainEquipmentCode: null,
        selectedMainEquipmentName: null,
        selectedSubEquipmentCode: null,
        selectedSubEquipmentName: null,
    };
    const [machineStates, setMachineStates] = useState(initialMachineStates);

    //detail popup
    const [detailOpen, setDetailOpen] = useState(false);
    const HandleDetailOpen = () => {
        LoadDetailData();
        setDetailOpen(true);
    };
    const HandleDetailClose = () => {
        setDetailOpen(false);
    };

    //cancel the action and delete all data for detail popup
    const HandleDetailCancel = () => {
        setSelectedBreakdownReasonPlaceCode();
        setSelectedPoolCode();
        setDetailOpen(false);
    };

    //QR Code
    let [qrOpen, setQrOpen] = useState(false);
    const [state, setState] = useState({
        result: "No result",
    });

    const qrRef = useRef();
    let executedScroll = false;

    const HandleScan = (data) => {
        executedScroll = qrScroll(qrRef, executedScroll);
        if (data) {
            setState({ ...state, result: data });
            dispatch(getEquipmentGetByBarcodeContext(data));
        }
    };

    // File Management
    const [breakdownFiles, setBreakdownFiles] = useState([]);
    const [formData, setFormData] = useState(new FormData());
    const [isFileUploaderPopupOpen, setIsFileUploaderPopupOpen] = useState(false);
    const UploadFiles = (files) => {
        console.log("files", files);
        const newFormData = getFormDataFromFiles(files);
        setFormData(newFormData);
        setBreakdownFiles(files);
        setIsFileUploaderPopupOpen(false);
    };

    // Validation
    const [error, setError] = useState({
        machineText: t("SelectAMachine"),
        breakdownEffectText: t("SelectABreakdownEffect"),
        breakdownReasonGroupText: t("SelectABreakdownReasonGroup"),
        breakdownNoteTextLength: t("MinCharacter"),
        emptyBreakdownNoteText: t("MinCharacter"),
    });
    const [isDisable, setIsDisable] = useState(true);

    const isMeaningfulNote = (note) => {
        const content = note.trim();
        return content.length >= 10 && /[A-Za-z0-9\u0400-\u04FF\u0600-\u06FF]/.test(content);
    };

    useEffect(() => {
        const newBreakdownEffectText = selectedBreakdownEffect ? "" : t("SelectABreakdownEffect");
        const newBreakdownReasonGroupText = selectedBreakdownReasonGroupCode ? "" : t("SelectABreakdownReasonGroup");
        const newBreakdownNoteTextLength = breakdownDetail.trim().length >= 10 ? "" : t("MinCharacter");
        const newEmptyBreakdownNoteText = isMeaningfulNote(breakdownDetail) ? "" : t("MinCharacter");
        setError({
            ...error,
            breakdownEffectText: newBreakdownEffectText,
            breakdownReasonGroupText: newBreakdownReasonGroupText,
            breakdownNoteTextLength: newBreakdownNoteTextLength,
            emptyBreakdownNoteText: newEmptyBreakdownNoteText,
        });
    }, [selectedBreakdownEffect, selectedBreakdownReasonGroupCode, breakdownDetail]);

    useEffect(() => {
        const noEffectError = error.breakdownEffectText === "";
        const noReasonError = error.breakdownReasonGroupText === "";
        const noNoteLengthError = error.breakdownNoteTextLength === "";
        const noEmptyNoteError = error.emptyBreakdownNoteText === "";
        const meaningfulNote = isMeaningfulNote(breakdownDetail);
        const hasEquipment = machineStates.selectedSubEquipmentCode || machineStates.selectedMainEquipmentCode;

        if (noEffectError && noReasonError && hasEquipment && noNoteLengthError && noEmptyNoteError && meaningfulNote) {
            setIsDisable(false);
        } else {
            setIsDisable(true);
        }
    }, [error, machineStates, breakdownDetail]);

    let [barcodeOpen, setBarcodeOpen] = useState(false);
    const OpenBarcodeScanner = () => {
        if (barcodeOpen) {
            return (
                <div>
                    <TextField
                        autoFocus
                        onChange={(e) => HandleScanBarcode(e)}
                        onKeyDown={handleKeypress}
                        style={{ width: "100%", marginBottom: 10, marginTop: 20 }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton edge="end" color="primary" onClick={handleSubmit}>
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
            );
        } else {
            return null;
        }
    };

    const HandleScanBarcode = (event) => {
        if (event.target.value) {
            setState({ ...state, result: event.target.value });
        }
    };

    const handleKeypress = (e) => {
        //it triggers by pressing the enter key
        if (e.keyCode === 13) {
            setBarcodeOpen(false);
            dispatch(getEquipmentGetByBarcodeContext(e.target.value));
        }
    };

    const handleSubmit = () => {
        setBarcodeOpen(false);
        dispatch(getEquipmentGetByBarcodeContext(state.result));
    };

    return (
        <div>
            {pageLoaded === true ? (
                <Container id="rb_container" fixed maxWidth="xs" style={{ marginTop: 20 }}>
                    <Grid container id="rb_grid" justifyContent="center" style={{ marginTop: 30 }}>
                        <Grid id="rb_grid_1" item xs={12}>
                            <IconButton id="rb_iconQrBtn" onClick={() => setQrOpen(true)}>
                                <QrCode2Icon id="rb_centerFcs" className={classes.button} color="primary" />
                            </IconButton>
                            <IconButton id="rb_iconQrBtn" onClick={() => setBarcodeOpen(true)}>
                                <CropFreeIcon id="rb_centerFcs" className={classes.button} color="primary" />
                            </IconButton>
                            {/* <TextField
                                id="ctbp_TextField_1"
                                multiline
                                maxRows={4}
                                defaultValue={t("ScanBarcodeOrChooseMachine")}
                                InputProps={{ readOnly: true }}
                                variant="outlined"
                                sx={{ width: "70%", marginTop: "10px" }}
                            /> */}
                        </Grid>
                        <Divider id="rb_divider" variant="middle" sx={{ width: "70%", marginTop: "10px" }} />
                        <Grid id="rb_grid_1" item xs={12}>
                            <TextField
                                id="ctbp_TextField_1"
                                multiline
                                maxRows={4}
                                defaultValue={t("ScanQRCodeOrChooseMachine")}
                                InputProps={{ readOnly: true }}
                                variant="outlined"
                                sx={{ width: "80%", marginTop: "10px" }}
                            />
                        </Grid>
                        <Grid id="rb_grid_2" item xs={12}>
                            {qrOpen === true ? (
                                <div ref={qrRef}>
                                    <QrReader id="rb_QrReader" scanDelay={500} onResult={HandleScan} constraints={{ facingMode: "environment" }} style={{ width: "100%", marginBottom: 10 }} />
                                </div>
                            ) : null}
                        </Grid>
                        {OpenBarcodeScanner()}
                        <Grid id="rb_grid_4" item xs={12} style={{ marginTop: 20 }}>
                            <FormControl id="rb_formControl" variant="outlined" style={{ width: "90%" }}>
                                <Machine setMachineStates={setMachineStates} machineStates={machineStates} isAreaNotFiltered={true} size="normal" error={error} setError={setError} />
                            </FormControl>
                        </Grid>
                        <Grid id="rb_grid_5" item xs={12} style={{ marginTop: 20 }}>
                            <FormControl id="rb_formControl_1" variant="outlined" style={{ width: "90%" }}>
                                <Autocomplete
                                    id="rb_breakdownEffect_autocomplete"
                                    style={{ marginTop: -10 }}
                                    defaultValue={""}
                                    onChange={(_event, newValue) => {
                                        HandleBreakdownEffectChange(newValue);
                                    }}
                                    options={breakdownEffectData.map((option) => option.breakdownEffectLocalizationName ?? option.name)}
                                    renderInput={(params) => (
                                        <TextField
                                            id="rb_textField_2"
                                            {...params}
                                            margin="normal"
                                            label={t("Effect")}
                                            variant="outlined"
                                            error={error.breakdownEffectText.length > 0}
                                            helperText={error.breakdownEffectText}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid id="rb_grid_6" item xs={12} style={{ marginTop: 20 }}>
                            <FormControl id="rb_formControl_2" variant="outlined" style={{ width: "90%" }}>
                                <Autocomplete
                                    id="rb_breakdownReasonGroup_autocomplete"
                                    defaultValue={""}
                                    style={{ marginTop: -20 }}
                                    onChange={(_event, newValue) => {
                                        HandleBreakdownReasonGroupChange(newValue);
                                    }}
                                    options={breakdownReasonGroupData.map((option) => option.breakdownReasonGroupLocalizationName ?? option.name)}
                                    renderInput={(params) => (
                                        <TextField
                                            id="rb_textField_6"
                                            {...params}
                                            margin="normal"
                                            label={t("BreakdownGroup")}
                                            variant="outlined"
                                            error={error.breakdownReasonGroupText.length > 0}
                                            helperText={error.breakdownReasonGroupText}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid id="rb_grid_7" item xs={12} style={{ marginTop: 20 }}>
                            <TextField
                                id="rb_textField_10"
                                style={{ width: "90%", marginTop: -5 }}
                                multiline
                                label={t("CallNote")}
                                variant="outlined"
                                onChange={HandleBreakdownDetail}
                                inputProps={{ maxLength: 550 }}
                                helperText={breakdownDetail.length === 550 ? t("MaxCharacter") : error.emptyBreakdownNoteText}
                                error={error.emptyBreakdownNoteText}
                            />
                        </Grid>
                        <Grid id="rb_grid_8" item xs={12} style={{ marginTop: 20 }}>
                            <Link id="rb_link" component="button" variant="body2" onClick={HandleDetailOpen}>
                                {t("ClickForDetails")}
                            </Link>
                        </Grid>
                        <Grid id="rb_grid_9" item xs={12} style={{ marginTop: 20 }}>
                            <Tooltip title={t("UploadFile")}>
                                <IconButton id="rb_iconBtn_1" size="large" onClick={() => setIsFileUploaderPopupOpen(true)} sx={{ marginRight: 1 }}>
                                    <CloudUpload id="rb_createNf" fontSize="large" />
                                </IconButton>
                            </Tooltip>
                            <Button id="openBreakDownRequest" onClick={handleBreakdownSubmit} variant="contained" color="primary" disabled={isDisable}>
                                {t("CreateBreakdownRequest")}
                            </Button>
                        </Grid>
                    </Grid>
                </Container>
            ) : null}

            {detailDataLoaded === true ? (
                <Container id="rb_container_1">
                    <Dialog id="rb_dialog" open={detailOpen} onClose={HandleDetailClose} fullWidth="xs">
                        <DialogTitle id="rb_dialogTitle">{t("SelectDetail")}</DialogTitle>
                        <DialogContent id="rb_dialogContent">
                            <form>
                                <FormControl id="rb_formControl_3" variant="outlined" style={{ width: "100%" }}>
                                    <Autocomplete
                                        id="rb_autocomplete"
                                        defaultValue={""}
                                        value={selectedBreakdownReasonPlaceName}
                                        margin="normal"
                                        onChange={(_event, newValue) => {
                                            HandleBreakdownReasonPlaceChange(newValue);
                                        }}
                                        options={breakdownReasonPlaceData.map((option) => option.breakdownReasonPlaceLocalizationName ?? option.name)}
                                        renderInput={(params) => <TextField {...params} margin="normal" label={t("BreakdownPlace")} variant="outlined" />}
                                    />
                                </FormControl>
                                <FormControl id="rb_formControl_4" variant="outlined" style={{ width: "100%" }}>
                                    <Autocomplete
                                        id="rb_autocomplete_8"
                                        defaultValue={""}
                                        value={selectedPoolName}
                                        margin="normal"
                                        onChange={(_event, newValue) => {
                                            HandlePoolChange(newValue);
                                        }}
                                        options={poolData.map((option) => option.name)}
                                        renderInput={(params) => <TextField {...params} margin="normal" label={t("Pool")} variant="outlined" />}
                                    />
                                </FormControl>
                            </form>
                        </DialogContent>
                        <DialogActions id="rb_dialogAct">
                            <Button id="rb_btnCancel" onClick={HandleDetailCancel} color="secondary">
                                {t("Cancel")}
                            </Button>
                            <Button id="rb_btnConfirm" onClick={HandleDetailClose} color="primary">
                                {t("Confirm")}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Container>
            ) : null}

            {isFileUploaderPopupOpen ? <FileUploaderPopup isOpen={isFileUploaderPopupOpen} files={breakdownFiles} onCancel={() => setIsFileUploaderPopupOpen(false)} onConfirm={UploadFiles} /> : null}

            <LoadingBackdrop id="rb_lgnBackdrop" />
        </div>
    );
}
